module.exports = __webpack_public_path__ + "static/media/BandejaGarcon.a5b03e0e.svg";